import { ThumbDownRounded, ThumbUpRounded } from '@mui/icons-material'
import { Avatar, Box, Chip, Divider, Skeleton, Typography } from '@mui/material'
import Helper from '../../../helpers/Helper'
import { LineChart } from '../../charts'
import { GetLineChartDefaultOptions } from '../../charts/LineChart'
import { ChartDataWithUnit } from '../../charts/ChartsHelper'

interface P {
    title: string
    body?: JSX.Element | JSX.Element[]
    chartData?: ChartDataWithUnit<'line', number[], unknown>
    explore?: () => void
    valuation?: boolean
    isLoading?: boolean
}

function InsightCard({ title, body, isLoading, chartData, valuation }: P) {
    const renderBody = () => {
        if (isLoading) {
            return (
                <>
                    <Skeleton variant='text' />
                    <Skeleton variant='text' width='80%' />
                </>
            )
        } else return body
    }

    const renderChart = () => {
        if (!chartData) return null
        return (
            <>
                <Divider sx={{ mr: -1, ml: -1, mt: 1, mb: 1 }} />
                <Box height='calc(var(--unit) * 25)' display='flex'>
                    <LineChart
                        data={chartData}
                        isLoading={isLoading}
                        options={{ ...GetLineChartDefaultOptions(), plugins: { ...GetLineChartDefaultOptions().plugins, legend: { display: chartData.datasets.length > 1 } } }}
                    />
                </Box>
            </>
        )
    }

    return (
        <Box flex={1} display='flex' flexDirection='column'>
            <Box flexDirection='row' display='flex' justifyContent='space-between'>
                <Chip label={title} size='small' />
                {(!isLoading && Helper.hasVal(valuation)) && (
                    <Avatar sx={{ height: 28, width: 28, backgroundColor: valuation ? 'success.main' : 'error.main' }}>
                        {valuation
                            ? <ThumbUpRounded fontSize='inherit' />
                            : <ThumbDownRounded fontSize='inherit' />}
                    </Avatar>
                )}
            </Box>
            <Typography variant='body2' sx={{ mt: 2 }}>{renderBody()}</Typography>
            {renderChart()}
        </Box>
    )
}

export default InsightCard
